import { render, staticRenderFns } from "./InstagramInstantwinPrize.vue?vue&type=template&id=56a15ddc"
import script from "./InstagramInstantwinPrize.vue?vue&type=script&setup=true&lang=ts"
export * from "./InstagramInstantwinPrize.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports